export default{
    //comapny-user
    GetCompnayReportItems(state){
      return state.companyReportItems
    }
  }